module.exports = __webpack_public_path__ + "img/public/SiteIcons/user-details-star.svg?871793c8";